<template>
  <bm-page-footer>
    <template #left>
      <bm-btn
        button-type="secondary"
        :icon="isMobileDisplay"
        data-qa="wizard_close"
        @click="closeWizard"
        ><template v-if="!isMobileDisplay">{{ $m.close }}</template
        ><v-icon v-if="isMobileDisplay">clear</v-icon>
      </bm-btn>
    </template>

    <bm-btn
      v-if="numSteps > 1"
      key="wizard_previous"
      btn-class="mr-2"
      button-type="secondary"
      :disabled="!canReturn"
      :icon="isMobileDisplay"
      :tooltip="$m.previous_step_hint"
      data-qa="wizard_previous"
      @click="previousWizard"
      ><template v-if="!isMobileDisplay">{{ $m.previous_step }}</template
      ><v-icon v-if="isMobileDisplay">arrow_back</v-icon>
    </bm-btn>

    <bm-btn
      v-if="numSteps > 1"
      key="wizard_next"
      btn-class="mr-2"
      button-type="secondary"
      :disabled="!canContinue"
      :icon="isMobileDisplay"
      :tooltip="$m.next_step_hint"
      data-qa="wizard_next"
      @click="nextWizard"
      ><template v-if="!isMobileDisplay">{{ $m.next_step }}</template
      ><v-icon v-if="isMobileDisplay">arrow_forward</v-icon>
    </bm-btn>

    <bm-btn
      key="wizard_finish"
      :disabled="!canComplete"
      :tooltip="$m.finish_hint"
      btn-class="mr-2"
      data-qa="wizard_finish"
      @click="finishWizard"
    >
      <slot name="footer-text">
        {{ $m.finish }}
      </slot>
    </bm-btn>
  </bm-page-footer>
</template>

<script lang="ts">
import BmPageFooter from "@/components/pages/BmPageFooter.vue";
import { defineComponent } from "vue";
import { WizardInputEventType } from "@/components/controls/wizard/WizardEvents";
import wizardStore from "@/store/modules/wizardStore";

function canComplete() {
  const onLastPage =
    wizardStore.state.stepNumber === wizardStore.state.numberOfSteps - 1;
  const atLastRequiredStep = wizardStore.state.atLastRequiredStep;
  return onLastPage || atLastRequiredStep;
}

export default defineComponent({
  name: "BmWizardFooter",
  components: { BmPageFooter },
  data() {
    return {};
  },
  computed: {
    numSteps() {
      return wizardStore.state.numberOfSteps;
    },
    canReturn() {
      return wizardStore.state.stepNumber > 0;
    },
    canContinue() {
      return wizardStore.state.stepNumber < wizardStore.state.numberOfSteps - 1;
    },
    canComplete: canComplete,
    isMobileDisplay() {
      return !this.$vuetify.breakpoint.smAndUp;
    },
  },
  methods: {
    closeWizard() {
      this.$root.$emit(WizardInputEventType.Close);
    },
    previousWizard() {
      this.$root.$emit(WizardInputEventType.PreviousStep);
    },
    nextWizard() {
      this.$root.$emit(WizardInputEventType.NextStep);
    },
    finishWizard() {
      // BREW-1794
      // NB: I have no idea what causes this, but when a new session is started then the first time a user navigates
      // to a wizard a native click event is thrown which fires this method.
      // If the user has already visited a wizard then this doesn't seem to happen.
      // To prevent this from validating the form before it's loaded, check this method can logically be called before
      // firing a Wizard Finished event.
      if (canComplete()) {
        this.$root.$emit(WizardInputEventType.Finished);
      }
    },
  },
});
</script>
